import { useState } from "react"
import { useApi } from "utils"
import { FinanceYearlyList, FinanceYearlySuccessFetch } from "../types/FinanceYearlyType"


export const yearlyApis = [
  {
    category: "FINANCIAL HEALTH",
    code_budget: "CB",
    key_description: "Cash Balance",
    url: "analytic/cash_balance/yearly_summary"
  },
  {
    category: "FINANCIAL HEALTH",
    code_budget: "FC_CR",
    key_description: "Current Ratio",
    url: "analytic-finance/fc-current-ratio/yearly_summary"
  },
  {
    category: "FINANCIAL HEALTH",
    code_budget: "FC_WC",
    key_description: "Working Capital",
    url: "analytic-finance/fc_working_capital/yearly_summary"
  },
  {
    category: "FINANCIAL HEALTH",
    code_budget: "FC_DTE",
    key_description: "Debt to Equity",
    url: "analytic-finance/finance_debt_to_equity/yearly_summary"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_R",
    key_description: "Revenue",
    url: "analytic-finance/finance_revenue/yearly_summary"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_COS",
    key_description: "Cost Of Sales",
    url: "analytic-finance/finance_cos_of_sales/yearly_summary"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_GM",
    key_description: "Gross Margin",
    url: "analytic-finance/finance_gross_margin_percentage_ratio/yearly_summary"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_E",
    key_description: "Expenses",
    url: "analytic-finance/finance_expences/yearly_summary"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_OM",
    key_description: "Operating Margin",
    url: "analytic-finance/finance_operating_margin_percentage_ratio/yearly_summary"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_NPL",
    key_description: "Net Profit / Loss",
    url: "analytic-finance/finance_net_profit/yearly_summary"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_RPE",
    key_description: "Revenue Per Employee",
    url: "analytic-finance/finance_revenue_per_employee/yearly_summary"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_ETER",
    key_description: "Expences To Employee Ratio",
    url: "analytic-finance/finance_expences_to_employee_ratio/yearly_summary"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_IT",
    key_description: "Inventory Turnover",
    url: "analytic-finance/efficiency_inventory_turnover/yearly_summary"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_AT",
    key_description: "Asset Turnover",
    url: "analytic-finance/efficiency_asset_turnover/yearly_summary"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_ROE",
    key_description: "Return On Equity",
    url: "analytic-finance/investor_return_on_equity/yearly_summary"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_ROA",
    key_description: "Return On Asset",
    url: "analytic-finance/investor_return_on_asset/yearly_summary"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_EBITDA",
    key_description: "EBITDA",
    url: "analytic-finance/investor_kpi_ebitda/yearly_summary"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_DTE",
    key_description: "Debt To Equity",
    url: "analytic-finance/investor_kpi_debt_to_equity/yearly_summary"
  },

]

export function useFinanceYearlyList(
  year?: number,
  location_id?: string | ""
) {
  const api = useApi()

  const [data, setData] = useState<FinanceYearlyList[]>([])
  const [loading, setLoading] = useState(false)

  const fetchData = async () => {
    if (!year) return
  
    setLoading(true)
  
    try {
      const params: any = { year }
  
      if (location_id && location_id !== "") {
        params.location_id = location_id
      }
  
      const responses = await Promise.all(
        yearlyApis.map(async (item) => {
          try {
            const res = await api.get(item.url, { params })
  
            const response: FinanceYearlySuccessFetch = res.data
  
            const payload = response.payload?.[0]
  
            return {
              ...payload,
              category: item.category,
              key_description: item.key_description,
              code_budget: item.code_budget
            }
          } catch {
            return {
              category: item.category,
              key_description: item.key_description,
              code_budget: item.code_budget,
              data: []
            }
          }
        })
      )
  
      setData(responses)
    } catch {
      setData([])
    } finally {
      setLoading(false)
    }
  }

  return {
    yearlyData: data,
    loading,
    refetchYearly: fetchData
  }
}